module.exports = __webpack_public_path__ + "img/Q90.88b206b1.png";